import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  children: React.ReactNode;
}
const useStyles = makeStyles(theme => ({
  root: {},
}));

const AppLayout: FC<Props> = ({ children }: Props) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default AppLayout;
